// extracted by mini-css-extract-plugin
module.exports = {"headingLine":"DynamicHeadingLine_headingLine__MwYOZ","marginSmall":"DynamicHeadingLine_marginSmall__uqL_L"};